import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import ProjectTeamManagementDetailsPage from "../../../components/SidebarMenuComponents/MasterComponent/ProjectTeamManagementDetailsPage";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function ProjectTeamManagement() {
    const location = useLocation();
    const proMaster = location.state;
    console.log("proMaster", proMaster);

    return (
        <Page title="  Product Master  | tiketic" >
            <StickyHeader
                title="Project Team Management"
                showButton={false}
            />

            <ContentStyle>
                <ProjectTeamManagementDetailsPage  />
            </ContentStyle>
        </Page>
    );
}

